export const handleValidationError = (error, toast, fallbackMsg) => {
    const responseErrors = error?.response?.data?.errors;
    const rawMsg = error?.response?.data?.message;
    const apiMsg = typeof rawMsg === 'string' ? rawMsg : (rawMsg?.message || error?.response?.data?.error);
    const fallbackMessage = apiMsg || (error?.response ? null : error?.message) || fallbackMsg || "An error occurred";
    
    if (responseErrors && Object.keys(responseErrors).length > 0) {
        const errorMessages = Object.values(responseErrors)
            .flat()
            .filter(Boolean); 

        toast.error(errorMessages.length > 1 
            ? errorMessages[0] 
            : errorMessages.join("<br/>")
        );
    } 
    else {
        toast.error(fallbackMessage);
    }
}